import { defineModel } from "../define-model";

export type AssistantThread = {
	id: string;
	workspaceId: string;
	/** `null` = workspace-scoped (not tied to one project). */
	projectId: string | null;
	/** `agent` threads are agent-run transcripts, never listed as chats. */
	kind: "chat" | "agent";
	title: string;
	model: string | null;
	createdById: string | null;
	lastMessageAt: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		assistantThread: AssistantThread;
	}
}

export const model = defineModel({
	name: "assistantThread",
	load: "eager",
	indexes: ["projectId"],
	defaults: ({ userId, workspaceId, now }) => ({
		workspaceId,
		projectId: null,
		kind: "chat" as const,
		title: "New thread",
		model: null,
		createdById: userId,
		lastMessageAt: null,
		archivedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => (b.lastMessageAt ?? b.createdAt).localeCompare(a.lastMessageAt ?? a.createdAt),
});
